import { useMediaQuery } from './useMediaQuery'

// The useBreakpoint from AntD v4 trigger a lot of rerenders and starts with a wrong value
// it causes layout shifts
// AntD v4 uses the breakpoints of responsive grid follow BootStrap 4 media queries rules
// https://4x.ant.design/components/grid/#Col
// https://getbootstrap.com/docs/4.0/layout/overview/#responsive-breakpoints

const BREAKPOINTS = {
  xs: '(max-width: 575px)',
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
  xxl: '(min-width: 1600px)',
}

type Breakpoint = keyof typeof BREAKPOINTS

function useBreakpoint(breakpoint: Breakpoint) {
  return useMediaQuery(BREAKPOINTS[breakpoint])
}

export const MOBILE_BREAKPOINT: Breakpoint = 'md'

export function useIsMobile() {
  return !useBreakpoint(MOBILE_BREAKPOINT)
}

export const TABLET_BREAKPOINT: Breakpoint = 'lg'

export function useIsTablet() {
  return !useBreakpoint(TABLET_BREAKPOINT)
}
